import React from 'react';
import GoogleLogin from 'react-google-login';
import Header from '../Headers';
import {Redirect} from 'react-router-dom';
import axios from 'axios';
import url from '../../config/url';
import googleAuth from '../../config/Auth';
import LoaderComponent from '../cAjaxLoader';
import { ToastContainer } from 'react-toastr';
import './login.css'
class Login extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            isLoggedIn: false,
            user:'',
            error:false,
            errorDesc:'',
            showLoader:false
        }
        this.responseGoogle = this.responseGoogle.bind(this);
        this.handleLogin = this.handleLogin.bind(this);
    }

    handleLogin(e){
        e.preventDefault();
        var email = this.email.value
        this.setState({showLoader:true})
        axios(url + '/getAdminDetailsFromEmail?email='+email)
        .then(response => {

            if(response.data.status){

                console.log('inside then of login api');
                sessionStorage.setItem('isLoggedIn',true);//set this only if response status is success from api 
                sessionStorage.setItem('at',response.data.successObject.branches[0].id);
                sessionStorage.setItem('by',response.data.successObject.adminId);
                this.setState({user:response.profileObj,isLoggedIn:true,showLoader:false});
                sessionStorage.setItem('loggedInUser', this.state.user)
            }
            else{
                this.refs.container.error(response.data.errorDescription);
                this.setState({showLoader:false});
            }
              console.log(response);
          })
          .catch(err => {
                this.setState({showLoader:false})
                // this.refs.container.error('Something went wrong')
                console.log(err);
          })
        
    }
    responseGoogle(response){
        console.log(response);
        var email = response.profileObj.email;
        this.setState({showLoader:true})
        //call login api if success store user in session and redirect to app
        // axios(url + 'admin/getAdminBranchesFromEmail?email='+email)
        axios(url + '/getAdminDetailsFromEmail?email='+email)
        .then(response => {
            if(response.data.status){

                console.log('inside then of login api');
                sessionStorage.setItem('isLoggedIn',true);//set this only if response status is success from api 
                sessionStorage.setItem('at',response.data.successObject.branches[0].id);
                sessionStorage.setItem('by',response.data.successObject.adminId);
                this.setState({user:response.profileObj,isLoggedIn:true,showLoader:false});
                sessionStorage.setItem('loggedInUser', this.state.user)
            }
            else{
                this.refs.container.error(response.data.errorDescription);
                this.setState({showLoader:false});
            }
              console.log(response);
          })
          .catch(err => {
                this.setState({showLoader:false})
                // this.refs.container.error('Something went wrong')
                console.log(err);
          })
          
    }
    
    render(){
        var shouldRedirect = this.state.isLoggedIn;
        return (
            
            <div>
            <ToastContainer 
                ref = "container"    
                className="toast-top-right"
            />
            <LoaderComponent showLoader = {this.state.showLoader}>
            {
                (shouldRedirect || sessionStorage.getItem('isLoggedIn')) ? <Redirect to = '/app'/>
                : 
                <div>
                    
                    <Header hname = "Warehouse Operation"/>
                    {/* <div className = "row "> */}
                    {this.state.error ? 
                    <div className = ""style = {{marginLeft:30,marginTop:30}} >
                        <p className="alert alert-danger text-danger"  >{this.state.errorDesc}</p>
                    </div>
                    :''

                    }
                    <div className="row">
                        <div className="col-sm-4 col-lg-4 col-md-4"></div>
                        <div className="card card-container col-sm-4 col-lg-4 col-md-4" style = {{margin:30}}>
                        <img id="profile-img" class="profile-img-card" src="//ssl.gstatic.com/accounts/ui/avatar_2x.png" />
                        <p id="profile-name" class="profile-name-card"></p>
                            <form onSubmit={this.handleLogin} className="form-signin">
                                <input type="email" id="inputEmail" ref = {(value)=>this.email=value} className="form-control" placeholder="Email address" required autoFocus/>
                                <button style = {{marginTop:10}} className="btn btn-md " type="submit">Sign in</button>

                            </form>

                            {/* <button onClick = {this.handleLogin}>Login</button> */}
                            {/* <GoogleLogin
                                className="btn"
                                style = {{margin:30}}
                                clientId= { googleAuth.clientId }
                                buttonText="Login With Google"
                                onSuccess={this.responseGoogle}
                                onFailure={this.responseGoogle}
                            /> */}
                        </div>
                        <div className="col-sm-4 col-lg-4 col-md-4"></div>
                      
                    </div>
                    
                </div>
            }
            </LoaderComponent>
            </div>
            
        )
    }
}
export default Login;


// WEBPACK FOOTER //
// ./src/Components/Login/Login.js